import React, { Component } from 'react';
import { SlButton, TextInput, SlBusyIndicator, SlFormEntryRow, SlSectionLabel, SlPageTitle, SlSectionTitle} from '../editors';
import { Card, CardBody, Row } from 'reactstrap';
import { connect } from "react-redux";
import { Alert } from 'reactstrap';
import validator from 'validator';
import { registrationActions } from "../../_actions";
import { metadataService, newLoanService, ServiceUtil, SessionService } from "../../_services";
import { IdentificationType } from "./IdentificationType";

class PreApproval extends Component {
    _isMounted = false;
    static displayName = PreApproval.name;

    constructor(props) {
        super(props);

        this.state = this.getDefaultState();

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleSetState = this.handleSetState.bind(this);
        this.handleDataChange = this.handleDataChange.bind(this);
        this.formHasError = this.formHasError.bind(this);
        this.isIdentificationTypeValid = this.isIdentificationTypeValid.bind(this);
        this.handleSSNChange = this.handleSSNChange.bind(this);
        this.isValidPhone = this.phoneHasError.bind(this);
    }

    getDefaultState() {
        var defaultState = {
            PreApprovalCode: "",
            SocialSecurityNumber: '',
            individualTaxIdentificationNumber: "",
            Itin: '',
            DOB: '',
            "everythingcorrect": false,
            PreApproved: false,
            canMoveNext: false,
            isBusy: false,
            socialSecurityNumberError: false,
            itinError: false,
            dobError: false,
            emailError: false,
            mobilePhoneError: false,
            preApprovalCodeError: false,
            useSSN: true,
            fieldErrors: [],
            existingCustomer: { existingCustomer: false }
        };

        return defaultState;
    }

    handleDataChange(event) {
        let targetName = event.target.name;
        var stateChanges = {}
        stateChanges[targetName] = event.target.value;

        const newState = this.setMoveNext(stateChanges);
        this.setState(newState);
    }

    handleSetState(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        stateChanges.canMoveNext = this.handleValidation(newState);
        this.setState(stateChanges);
    }

    handleValidation = (stateData) => {

        let formError = this.formHasError(stateData);

        return formError;
    };

    isIdentificationTypeValid(fieldName, isValid) {
        this.handleChangeState({ ...this.state, formError: !isValid, ssnItinError: !isValid });
    }

    handleChangeState(newState) {
        newState.formError = this.formHasError(newState);
        this.setState(newState)
    }

    handleSSNChange = ({ target: { name, value } }) => {

        var targetName = '';

        if (name === "SocialSecurityNumber") {
            targetName = 'SocialSecurityNumber';
        }
        else {
            targetName = 'individualTaxIdentificationNumber';
        }

        var stateChanges = {};
        stateChanges[targetName] = value;
        const newState = this.setMoveNext(stateChanges);
        this.setState(newState);
    };

    formHasError(checkState) {

        let socialSecurityError = false;
        let itinError = false;
        let dobError = false;
        let emailError = false;
        let preApprovalCodeError = false;
        let fieldErrors = [];

        this.setState({ fieldErrors: fieldErrors });

        if (checkState.SocialSecurityNumber) {
            socialSecurityError = validator.isEmpty(checkState.SocialSecurityNumber + '');
        }

        if (checkState.Itin) {
            itinError = validator.isEmpty(checkState.Itin + '');
        }
                
        dobError = validator.isEmpty(checkState.DOB + '');
        emailError = (validator.isEmpty(checkState.Email + '') || !validator.isEmail(checkState.Email + ''));
        preApprovalCodeError = validator.isEmpty(checkState.PreApprovalCode);

        return ((socialSecurityError || itinError) || (dobError) || (emailError) || (preApprovalCodeError));
    }

    componentDidMount() {
        this._isMounted = true;
        SessionService.setPersonalInfo(null);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    setMoveNext(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        let canMoveNext = this.handleValidation(newState) === false && this.phoneHasError(newState, false) === false;
        return { ...stateChanges, ...{ canMoveNext: canMoveNext, errorMessage: null } };
    }

    phoneHasError(checkState, showError) {
        let mobilePhoneError = false;
        let fieldErrors = [];

        if (validator.isEmpty(checkState.MobilePhone + '')) {
            mobilePhoneError = true;
        }

        if (mobilePhoneError === false) {
            mobilePhoneError = (!validator.isMobilePhone(checkState.MobilePhone + '', 'en-US'));
        }       

        if (mobilePhoneError === false && checkState.MobilePhone.length > 0) {
            mobilePhoneError = metadataService.MobileNumberBeginsWithOneOrZero(checkState.MobilePhone);
        }

        if (mobilePhoneError && showError === true) {
            fieldErrors.push({ fieldName: "MobilePhone", messageName: "MobilePhoneError" });
            this.setState({ fieldErrors: fieldErrors });
        }

        return mobilePhoneError;
    }

    handleSubmit = () => {
        const { dispatch } = this.props;

        if (this.handleValidation(this.state) === false && this.phoneHasError(this.state,true) === false) {

            this.setState({ isBusy: true });

            return window.grecaptcha.ready(() => {
                ServiceUtil.getReCaptchaSiteKey().then(siteKey => {
                    window.grecaptcha.execute(siteKey, { action: 'submit' }).then(token => {
                        ServiceUtil.verifyReCaptcha(token).then(verified => {

                            if (verified) {

                                var validationModel = {
                                    "DateOfBirth": this.state.DOB,
                                    "SSN": this.state.SocialSecurityNumber ? this.state.SocialSecurityNumber : this.state.individualTaxIdentificationNumber,
                                    "PreApprovalCode": this.state.PreApprovalCode
                                };
                                newLoanService.validatePreApprovalCode(validationModel).then(preApprovalCodeData => {
                                    if (preApprovalCodeData.status === 0 && preApprovalCodeData.data.isCodeValid === true) {

                                        var info = {
                                            "email": this.state.Email,
                                            "mobileNumber": this.state.MobilePhone,
                                            "preApprovalCode": this.state.PreApprovalCode,
                                            "userHash": preApprovalCodeData.data.userHash,
                                            "firstName": preApprovalCodeData.data.firstName,
                                            "lastName": preApprovalCodeData.data.lastName,
                                            "address": preApprovalCodeData.data.address1,
                                            "address2": preApprovalCodeData.data.address2,
                                            "city": preApprovalCodeData.data.city,
                                            "userState": preApprovalCodeData.data.state,
                                            "zipCode": preApprovalCodeData.data.postalCode,
                                            "requestedAmount": '',
                                            //despite having a userHash, these are needed still for downstream pages
                                            "socialSecurityNumber": this.state.SocialSecurityNumber,
                                            "individualTaxIdentificationNumber": this.state.individualTaxIdentificationNumber,
                                            "dateOfBirth": this.state.DOB                                            
                                        };
                                        SessionService.setPersonalInfo(info);

                                        dispatch(registrationActions.handleExistingCustomerRequest(this.state.existingCustomer));
                                    } else {
                                        this.setState({ isBusy: false, preApprovalCodeError: true });
                                    }
                                });
                            }
                            else {
                                this.setState({ isBusy: false, preApprovalCodeError: true });
                            }
                        });
                    });
                });
            });

        }
    }

    handleBack = () => {
        const { dispatch } = this.props;
        dispatch(registrationActions.handleExistingCustomerRequest(this.state.existingCustomer));
    }

    handleChange(event) {
        this.handleSetState({ value: event.target.value });
    }

    render() {
        var identityType = this.state.individualTaxIdentificationNumber ?
            { individualTaxIdentificationNumber: this.state.individualTaxIdentificationNumber } :
            { socialSecurityNumber: this.state.SocialSecurityNumber };

        return (
            <div className="PreApproval">
                <SlBusyIndicator visible={this.state.isBusy} />
                {this.state.preApprovalCodeError === true && (
                    <Row className="justify-content-center">
                        <Alert color="danger" style={{ margin: "0px", lineHeight: "1.2em" }}>
                            {metadataService.getMessage('PreApprovalCodeInvalid')}
                        </Alert>
                    </Row>
                )}
                <div>
                    <Card>
                        <CardBody className="noPadBottom">
                            {/*<SlSectionTitle sectionName={"LetsVerifyYourPreApprovalInformation"} />*/}
                            <SlPageTitle pageName="LetsVerifyYourPreApprovalInformation" />
                            <SlFormEntryRow>
                                <TextInput name="PreApprovalCode" value={this.state.PreApprovalCode} onChange={this.handleDataChange} maxLength='20' />
                            </SlFormEntryRow>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody className="noPadBottom">
                            <IdentificationType
                                name={"SocialSecurityNumber"}
                                value={identityType}
                                isRequired={true}
                                showLabel={true}
                                fieldErrors={this.state.fieldErrors}
                                onChange={this.handleSSNChange}
                                isValid={this.isIdentificationTypeValid}
                            />
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody className="noPadBottom">
                            <SlFormEntryRow>
                                <TextInput name='DOB' value={this.state.DOB} onChange={this.handleDataChange} type='date' />
                            </SlFormEntryRow>
                            <SlSectionLabel sectionName={"ContactInformation"} />
                            <SlFormEntryRow>
                                <TextInput name="Email" value={this.state.Email} onChange={this.handleDataChange} />
                            </SlFormEntryRow>
                            <SlFormEntryRow>
                                <TextInput name="MobilePhone" value={this.state.MobilePhone} onChange={this.handleDataChange} fieldErrors={this.state.fieldErrors} type='number' maxLength='10' />
                            </SlFormEntryRow>
                        </CardBody>
                    </Card>
                </div>
                <SlFormEntryRow>
                    <div className="text-center display-flex">
                        <div style={{width:  "50%"}}>
                            <SlButton name="Back" cssClass="backBtn" onClick={this.handleBack} />
                        </div>
                        <div style={{width: "50%"}}>
                            <SlButton name="Next" onClick={this.handleSubmit} disabled={!this.state.canMoveNext} />
                        </div>
                    </div>
                </SlFormEntryRow>
            </div>
        );
    }
}

function mapStateToProps(state) {

    const { loggedIn } = state.authentication;
    return {
        loggedIn
    };
}

const connectedPreApproval = connect(mapStateToProps)(PreApproval);
export { connectedPreApproval as PreApproval };



// WEBPACK FOOTER //
// ./src/components/subcomponents/PreApproval.js